import type { ApiUserResponse } from '../../services/authentication/types';
import { fetchPythonEndpoint } from '../../services/react-query';

const USER_FIELDS = [
	'*',
	'group.*',
	'group.cleanup',
	'group.admin.email',
	'group.subscription.*',
	'group.subscription.subscriptionPlan.*',
	'group.subscription.pending.renewalSubscriptionPlan.*',
	'group.admin.name',
	'group.itemTypes',
	'group.bookingSettings',
	'customer.*',
	'customer.user.picture',
	'picture',
	'userRole.permissions',
	'userRole.restrictLocations',
].join(',');

/**
 * Fetches the current user from the Python API (users/call/me).
 * Uses fetchPythonEndpoint (API_URL + auth from Authentication). Map to User in the auth layer.
 */
export async function fetchUser(userId: string): Promise<ApiUserResponse> {
	const fetcher = fetchPythonEndpoint<ApiUserResponse, { _fields: string }>(
		`${userId}/null/jwt/users/call/me`,
		{ _fields: USER_FIELDS },
		'GET'
	);
	return fetcher();
}
